import React from 'react';
import { ExpandMore } from '@mui/icons-material';
import { Typography, AccordionSummary, AccordionDetails, Accordion } from '@mui/material';
import { ICourseData } from '../../types/course-data';
import { ModalAccordionList } from './modal-accordion-list';

interface LessonListProps {
  lessonCount: number;
  title?: string;
  lessons: ICourseData['lessons'];
}

export const LessonList: React.FC<LessonListProps> = ({ lessonCount, title, lessons }) => {
  return (
    <Accordion className="mt-4 w-full bg-background rounded-xl border-0 shadow-none">
      <AccordionSummary expandIcon={<ExpandMore color="primary" />}>
        <span className="w-full flex justify-between px-2 items-center">
          <Typography variant="s1">Lista lezioni</Typography>
          <Typography variant="body-small-500" className="self-center min-h-[24px]">
            {lessonCount} video
          </Typography>
        </span>
      </AccordionSummary>
      <AccordionDetails>
        {lessons?.map((lesson, index) => (
          <ModalAccordionList
            key={index}
            title={lesson.title}
            duration={lesson.duration || 0}
            status={lesson.status}
            isLastItem={index === lessons.length - 1}
          />
        ))}
      </AccordionDetails>
    </Accordion>
  );
};
